import React, { useState } from 'react';
import { Sidebar, NavViewId } from './Sidebar';
import { Header, ProfileTab } from './Header';
import { useAuth } from '../../context/AuthContext';

interface ShellProps {
  children: (activeView: NavViewId) => React.ReactNode;
  activeView: NavViewId;
  onSelectView: (view: NavViewId) => void;
  onNavigateToProfile?: (tab: ProfileTab) => void;
}

const VIEW_TITLES: Record<NavViewId, string> = {
  dashboard: 'Executive Dashboard & Live Analytics',
  users: 'User Directory & KYC Verification Queue',
  deleted_accounts: 'Deleted Accounts Security Audit & Scrub',
  escrow: 'Escrow Monitor & Financial Settlement Ledger',
  disputes: 'Dispute Mediation Tribunal & Evidence',
  listings: 'Marketplace Catalog & Content Moderation',
  cms: 'CMS: Eco-News, Blog & Community Events',
  broadcast: 'Broadcast Push Notifications (FCM)',
  support: 'Support Ticket Helpdesk & Triage',
  audit: 'System RBAC & Security Audit Trail',
  admin_team: 'Admin Team Directory & Mobile App Governance',
  email_templates: 'Transactional Email Templates',
  profile_settings: 'Admin Profile, 2FA Authenticator & Security',
  vouchers: 'Escrow Fee Credit Vouchers & In-App Coupons',
  admin_chat: 'Admin Team Chat & Shift Handover Desk',
};

export const Shell: React.FC<ShellProps> = ({
  children,
  activeView,
  onSelectView,
  onNavigateToProfile,
}) => {
  const { currentUser } = useAuth();
  const [unreadNotifications, setUnreadNotifications] = useState(3);

  return (
    <div className="flex min-h-screen bg-[#0D1E18] dark:bg-[#0D1E18] text-[#f5f5f0] light:bg-[#F0FBF5] light:text-[#0D1C17] transition-colors">
      {/* Fixed Sidebar */}
      <Sidebar 
        activeView={activeView} 
        onSelectView={onSelectView} 
        role={currentUser?.role}
      />

      {/* Main Content Pane */}
      <div className="flex-1 flex flex-col min-w-0 overflow-x-hidden">
        <Header 
          currentViewTitle={VIEW_TITLES[activeView]}
          onOpenNotifications={() => setUnreadNotifications(0)}
          unreadCount={unreadNotifications}
          onNavigateToProfile={onNavigateToProfile}
          onNavigateToChat={() => onSelectView('admin_chat')}
        />

        <main className="flex-1 p-6 sm:p-8 lg:p-10 max-w-7xl w-full mx-auto">
          {children(activeView)}
        </main>
      </div>
    </div>
  );
};
